import { init, Integrations } from '@sentry/browser';
import { environment } from '@environments/environment';
import { SentryEnvironment } from '@shared/sentry/sentry.types';

export function getSentryEnvironment(): SentryEnvironment {
  if (environment.sentry?.environment) {
    return environment.sentry.environment;
  }

  if (environment.production && environment.prodMode) {
    return SentryEnvironment.PRODUCTION;
  }

  if (environment.prodMode) {
    return SentryEnvironment.STAGE;
  }

  if (environment.production) {
    return SentryEnvironment.REVIEW;
  }

  return SentryEnvironment.DEVELOPMENT;
}

export function initSentryClient(): void {
  if (!environment.sentry?.enabled) {
    return;
  }

  init({
    dsn: environment.sentry.dsn,
    environment: getSentryEnvironment(),
    defaultIntegrations: false,
    integrations: [new Integrations.UserAgent()],
    normalizeDepth: 8,
    release: '3.2.0',
  });
}
